import { clsx } from "clsx";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

async function request(path, { method = "GET", body, params } = {}) {
  let url = `${API}${path}`;
  if (params) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    const s = qs.toString();
    if (s) url += `?${s}`;
  }
  const res = await fetch(url, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 204) return null;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(formatApiErrorDetail(data?.detail) || "Errore");
    err.status = res.status;
    throw err;
  }
  return data;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const api = {
  get: (path, params) => request(path, { params }),
  post: (path, body) => request(path, { method: "POST", body }),
  put: (path, body) => request(path, { method: "PUT", body }),
  patch: (path, body) => request(path, { method: "PATCH", body }),
  del: (path, body) => request(path, { method: "DELETE", body }),
};

export async function downloadCsv(path, filename, params) {
  let url = `${API}${path}`;
  if (params) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    const s = qs.toString();
    if (s) url += `?${s}`;
  }
  const res = await fetch(url, { credentials: "include" });
  if (!res.ok) throw new Error("Esportazione fallita");
  const blob = await res.blob();
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export const cx = clsx;

export async function uploadFile(file) {
  const body = new FormData();
  body.append("file", file);
  const res = await fetch(`${API}/uploads`, { method: "POST", credentials: "include", body });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(formatApiErrorDetail(data?.detail) || "Caricamento non riuscito");
  return data;
}

export async function uploadFiles(path, files) {
  const body = new FormData();
  Array.from(files).forEach((f) => body.append("files", f));
  const res = await fetch(`${API}${path}`, { method: "POST", credentials: "include", body });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(formatApiErrorDetail(data?.detail) || "Import non riuscito");
  return data;
}

export const fileUrl = (id, download = false) => `${API}/uploads/${id}${download ? "?download=1" : ""}`;
